const inspectionList = {
  backbtn: "Go Back",
  inspectionList: "Inspection List",
  search: "Search",
  equipmentTag: "Equipment Tag",
  customer: "Customer",
  inspectionDate: "Inspection Date",
  zone: "Zone"
};
export default inspectionList;
